module.exports = __webpack_public_path__ + "static/media/sustainability-resized.d7be94bc.jpg";